export default "/images/aa6981328b5a44980dfb42b93f3a5a11.jpg";